<bl-modal-content #content
  [title]="'画面動作設定'"
>
  <div body>
    <div class="contents">
      <div class="setting-item setting-item--explanation">
        画面を開いた時にフォーカスが当たる箇所を選択してください。
      </div>
      <div class="setting-item">
        <div class="setting-item__label">
          <label>初期フォーカス</label>
        </div>
        <div class="setting-item__input">
          <bl-radio-group
            #firstFocusInput
            [(value)]="_screenActionSetting && _screenActionSetting.firstFocusDiv"
            groupType="inline"
            [items]="_firstFocusItems"
          ></bl-radio-group>
        </div>
      </div>
      <div class="setting-item setting-item--notice">
        ※画面動作設定はご利用のアカウントごとに保存されます。
      </div>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/recept-screen-action-setting-modal/recept-screen-action-setting-modal.component.html